/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import type Mithril from 'mithril';
import BookshelfArticleCount from './BookshelfArticleCount';
import BookshelvesListItem from './BookshelvesListItem';
import type Bookshelf from '../../common/models/Bookshelf';

export interface ActiveBookshelfItemAttrs extends ComponentAttrs {
	bookshelf: Bookshelf;
	position: number;
}

export default class ActiveBookshelfItem<CustomAttrs extends ActiveBookshelfItemAttrs = ActiveBookshelfItemAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelf, position } = this.attrs;
		const n = bookshelf.recentActivityCount();

		return (
			<div className="ActiveBookshelfItem">
				<Link href={app.route.book_collection(bookshelf)}>
					<span className="ActivityLeaderItem-position">{position.toString().padStart(2, '0')}</span>
					<BookshelvesListItem bookshelf={bookshelf} />
					<div className="ActiveBookshelfItem-details">
						<div className="ActiveBookshelfItem-details-name">{bookshelf.name()}</div>
						<div className="ActiveBookshelfItem-details-bookCount">
							<BookshelfArticleCount bookshelf={bookshelf} />
							&nbsp;-&nbsp;
							<span className="ActiveBookshelfItem-details-newCount">
								{app.translator.trans('glowingblue-orell-bookshelf.forum.home.active_bookshelves.new_books', { n })}
							</span>
						</div>
						<div className="ActiveBookshelfItem-details-user">
							{avatar(bookshelf.user() || null)}
							{username(bookshelf.user())}
						</div>
					</div>
				</Link>
			</div>
		);
	}
}
